/*
  Cart drawer upsell. Rewritten 2026-10-23 — see snippets/cart-drawer-recommendations.liquid
  for the host and sections/cart-upsell.liquid for the cards.

  The drawer replaces its own HTML after every cart change, which disconnects and
  reconnects this element. Results are cached by cart contents (data-key), so a
  re-render paints instantly from memory and only a real change in the cart
  fetches again.
*/
(function () {
  if (customElements.get('mgb-cart-upsell')) return;

  var cache = new Map();

  class MgbCartUpsell extends HTMLElement {
    connectedCallback() {
      var key = this.dataset.key;
      if (cache.has(key)) {
        this.fill(cache.get(key));
        return;
      }
      fetch(this.dataset.url)
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then((text) => {
          var inner = text && new DOMParser().parseFromString(text, 'text/html').querySelector('[data-mgb-upsell-inner]');
          var html = inner ? inner.innerHTML.trim() : '';
          cache.set(key, html);
          this.fill(html);
        })
        .catch(function () { /* no upsell is better than a broken one */ });
    }

    fill(html) {
      if (!this.isConnected) return;
      if (!html) {
        this.hidden = true;
        return;
      }
      this.innerHTML = html;
      this.hidden = false;
      if (this.wired) return;
      this.wired = true;
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
    }

    /* Variant chosen: the card's price, link and photo follow it. */
    onChange(event) {
      var select = event.target.closest('select[name="id"]');
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      var card = select.closest('.mgb-upsell__card');
      if (!opt || !card) return;

      var price = card.querySelector('[data-mgb-upsell-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;

      if (opt.dataset.url) {
        card.querySelectorAll('a').forEach(function (a) { a.href = opt.dataset.url; });
      }

      var img = card.querySelector('[data-mgb-upsell-img]');
      if (img && opt.dataset.img) {
        img.removeAttribute('srcset');
        img.src = opt.dataset.img;
      }
    }

    onSubmit(event) {
      var form = event.target.closest('[data-mgb-upsell-form]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('.mgb-upsell__add');
      var error = form.querySelector('.mgb-upsell__error');
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;

      var drawer = document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', new FormData(form).get('id'));
      body.append('quantity', '1');
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
      }

      var addUrl = (window.routes && window.routes.cart_add_url) ||
        (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add');

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      })
        .then(function (res) { return res.json(); })
        .then(function (state) {
          if (state.status) {
            button.removeAttribute('aria-busy');
            if (error) {
              error.textContent = state.description || state.message || (window.cartStrings && cartStrings.error) || '';
              error.hidden = false;
            }
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: body.get('id'), cartData: state });
          }
          if (drawer && drawer.renderContents && state.sections) {
            drawer.renderContents(state);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          button.removeAttribute('aria-busy');
          if (error) {
            error.textContent = (window.cartStrings && cartStrings.error) || 'Something went wrong. Please try again.';
            error.hidden = false;
          }
        });
    }
  }

  customElements.define('mgb-cart-upsell', MgbCartUpsell);
})();
